import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import styles from './style'
import { cameraPropSelector } from 'selectors/components'
import { DOWNTILT_PREVIEW_DIMENSIONS, CAMERA_SELECTED_RGB_COLORS } from 'helpers/globals'

const iconPath = 'm 2 .6 c -1 0 -1.3 0.7 -0.9 1.5 l 1.4 2.4 c 0.5 0.8 1.7 1.5 2.6 1.5 h 2.1 c 1 0 2.1 -0.7 2.6 -1.5 l 1.4 -2.4 c 0.5 -0.8 0.1 -1.5 -0.9 -1.5 l -8.3 0 l 0 0 z m -0.9 23 c 0 1 0.8 1.7 1.7 1.7 h 6.8 c 1 0 1.7 -0.8 1.7 -1.7 v -14.4 c 0 -1 -0.8 -1.7 -1.7 -1.7 h -6.8 c -1 0 -1.7 0.8 -1.7 1.7 v 14.4 l 0 0 z'

const mapStateToProps = state => ({
  tilt: cameraPropSelector('tilt')(state),
  cameraHeight: cameraPropSelector('cameraHeight')(state)
})

class CameraHeightLabel extends React.Component {
  render() {
    const { props: { cameraPxHeight, angle, classes, tilt, cameraHeight, unit, color } } = this
    const { maxCameraIconHeight } = DOWNTILT_PREVIEW_DIMENSIONS
    return (
      <div
        className={classes.container}
        style={{ height: cameraPxHeight > maxCameraIconHeight ? maxCameraIconHeight : cameraPxHeight }}
      >
        <svg
          viewBox='0 0 12.4 26'
          className={classes.cameraIcon}
          style={{ transform: `rotateZ(${-(tilt - angle / 2) + 90}deg)` }}
        >
          <path d={iconPath} stroke={`rgba(${CAMERA_SELECTED_RGB_COLORS[color]}, 0.80)`} fill='none' strokeWidth='2' />
        </svg>
        <span
          className={classes.heightDisplay}
          style={{ bottom: cameraPxHeight > 50 ? 'calc(50% - 11px)' : 'calc(100% + 15px)' }}
        >
          {`${Math.round(cameraHeight)}${unit}`}
        </span>
        <div className={classes.dividerLineHeight} />
      </div>
    )
  }
}

export default connect(mapStateToProps)(
  injectSheet(styles)(CameraHeightLabel)
)



// WEBPACK FOOTER //
// ./src/components/BlindSpotPanelContainer/DowntiltDisplayContainer/CameraHeightLabel/index.js